import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from './auth.service';
import { UserApiService } from 'src/app/services/api/user.api.service';
import { environment } from '../../environments/environment';

@Injectable()
export class EmailGuardService implements CanActivate {
  constructor(
    public authService: AuthService,
    public userApiService: UserApiService,
    public router: Router,
  ) {}

  async canActivate(): Promise<boolean> {
    const user = await this.userApiService.getAdmin();
    if (user.role === 'mowa_admin') {
      return true;
    }

    this.router.navigateByUrl('/');
    return false;
  }
}
